// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-3sKk","row":"row-3qBO","item":"item-21oe","logo":"logo-1DC4"};